import axios from "axios";
import { message } from "antd";
import { sessionStoragegetItem } from "./Helpers";
import { SaveUserAppLogUrl } from "./apiUrl";

const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
const authHeader = () => ({
  Authorization: `Bearer ${sessionStoragegetItem('token')}`,
});

// ── Activity logging: every request made through `client` is logged here ──
// (success or failure) so no individual page needs to log its own API calls.
const deriveActivityMeta = (config) => {
  const path = (config?.url || "").split("?")[0];
  const parts = path.split("/").filter(Boolean);
  const action = parts[parts.length - 1] || path || "unknown";
  const moduleName = parts[parts.length - 2] || "";
  return { action, moduleName };
};

// ActivityDesc is NVARCHAR(500) in the DB — keep everything within that budget.
const safeStringify = (value, maxLen) => {
  if (value === undefined || value === null || value === "") return "";
  let str;
  try {
    str = typeof value === "string" ? value : JSON.stringify(value);
  } catch {
    return "";
  }
  if (!str) return "";
  return str.length > maxLen ? `${str.slice(0, maxLen)}…` : str;
};

const logApiActivity = (config, status, responseData) => {
  if (!config || (config.url || "").includes("SaveUserAppLog")) return; // avoid logging the logger itself
  const { action, moduleName } = deriveActivityMeta(config);
  const method = (config.method || "").toUpperCase();

  const reqStr = safeStringify(config.data, 160);
  const resStr = safeStringify(responseData, 160);

  let activityDesc = `${method} ${config.url}`;
  if (reqStr) activityDesc += ` | Req: ${reqStr}`;
  if (resStr) activityDesc += ` | Res: ${resStr}`;
  if (activityDesc.length > 500) activityDesc = `${activityDesc.slice(0, 499)}…`;

  client({
    method: "POST",
    url: SaveUserAppLogUrl,
    data: {
      ActivityType: `${method}_${action}`,
      ActivityDesc: activityDesc,
      ModuleName: moduleName,
      DeviceInfo: typeof navigator !== "undefined" ? navigator.userAgent : "",
      Status: status,
    },
    headers: { ...authHeader() },
  }).catch(() => {}); // logging must never disrupt the UI
};

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    Authorization: `Bearer ${sessionStoragegetItem('token')}`,
    "Content-Type": "application/json",
  },
});

class APIService {
  static get(path = "") {
    return client({
      method: "GET",
      url: path,
      headers: { ...authHeader() },
    });
  }

  static post(path = "", data = {}, optionalHeader = {}) {
    return client({
      method: "POST",
      url: path,
      data,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static patch(path = "", data = {}) {
    return client({
      method: "PATCH",
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static put(path = "", data = {}) {
    return client({
      method: "PUT",
      url: path,
      data,
      headers: { ...authHeader() },
    });
  }

  static delete(path = "") {
    return client({
      method: "DELETE",
      url: path,
      headers: { ...authHeader() },
    });
  }

}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use((config) => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  const requestConfig = config;
  const { headers } = config;
  requestConfig.headers = {
    ...headers,
    Authorization: `Bearer ${sessionStoragegetItem('token')}`,
  };

  return requestConfig;
});

client.interceptors.response.use(
  (response) => {
    logApiActivity(response.config, "SUCCESS", response.data);
    return response;
  },
  (error) => {
    logApiActivity(error.config, "FAILED", error.response?.data);
    return Promise.reject(error);
  },
);

// client.interceptors.response.use(
//   (response) => {
//     if(response.data.data && Array.isArray(response.data.data)){
//       // Hide Success messages on list api
//     }else{
//       message.success({
//         content: response.data.message,
//         style: {
//           float: "right",
//           marginTop: "2vh",
//         },
//       });
//     }
//     return response;
//   },
//   (error) => {
//     /**
//      * Do something in case the response returns an error code [3**, 4**, 5**] etc
//      * For example, on token expiration retrieve a new access token, retry a failed request etc
//      */
//     const { response } = error;
  
//     const originalRequest = error.config;
//     if (response) {
//       if (response.status === 500) {
//         // To Do
//       } else if (response.status === 400) {
//         message.error({
//           content: response.data.message,
//           style: {
//             float: "right",
//             marginTop: "2vh",
//           },
//         });
//       }else if (response.status === 403){
//         message.error({
//           content: response.data.message,
//           style: {
//             float: "right",
//             marginTop: "2vh",
//           },
//         });
//       } else {
//         return originalRequest;
//       }
//     } else {
//       message.error({
//         content: `Something went wrong. Please check your internet connection and try again!`,
//         style: {
//           float: "right",
//           marginTop: "2vh",
//         },
//       });
//     }
//     return Promise.reject(error);
//   }
// );
export { APIService };